import axios from "axios";

const API_BASE_URL =
"https://adminappbackend.onrender.com";

const api = {
  
  // ✅ Fetch All Accounts
  getAccounts: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/accounts`);
      return response.data;
    } catch (error) {
      console.error("Error fetching accounts:", error);
      return [];
    }
  },

  // ✅ Create New Account
  createAccount: async (accountData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/accounts`, accountData);
      return response.data;
    } catch (error) {
      console.error("Error creating account:", error);
      return null;
    }
  },

  // ✅ Delete Account
  deleteAccount: async (accountId) => {
    try {
      await axios.delete(`${API_BASE_URL}/accounts/${accountId}`);
      return true;
    } catch (error) {
      console.error("Error deleting account:", error);
      return false;
    }
  },

  // ✅ Fetch Transactions for an Account
  getTransactions: async (accountId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/accounts/${accountId}/transactions`);
      return response.data;
    } catch (error) {
      console.error("Error fetching transactions:", error);
      return [];
    }
  },

  // ✅ Fetch Transactions for a Specific Month
getTransactionsByMonth: async (accountId, year, month) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/accounts/${accountId}/transactions?year=${year}&month=${month}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching transactions by month:", error);
    return [];
  }
},


  // ✅ Add Transaction
  addTransaction: async (accountId, transactionData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/accounts/${accountId}/transactions`, transactionData);
      return response.data;
    } catch (error) {
      console.error("Error adding transaction:", error);
      return null;
    }
  },

  // ✅ Edit Transaction
  editTransaction: async (transactionId, transactionData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/transactions/${transactionId}`, transactionData);
      return response.data;
    } catch (error) {
      console.error("Error editing transaction:", error);
      return null;
    }
  },

  // ✅ Delete Transaction
  deleteTransaction: async (transactionId) => {
    try {
      await axios.delete(`${API_BASE_URL}/transactions/${transactionId}`);
      return true;
    } catch (error) {
      console.error("Error deleting transaction:", error);
      return false;
    }
  },


sendLoanReminder: async (loanId) => {
  const response = await axios.post(
    `${API_BASE_URL}/loans/${loanId}/reminder`
  );

  return response.data;
},


sendOverdueReminder: async (
  loanId
) => {
  const response =
    await axios.post(
      `${API_BASE_URL}/loans/${loanId}/overdue-reminder`
    );

  return response.data;
},

// Cheques endpoint//
  // ✅ Fetch All Cheques
  getCheques: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/cheques`);
      return response.data;
    } catch (error) {
      console.error("Error fetching cheques:", error);
      return [];
    }
  },

  // ✅ Fetch a Single Cheque by Number
  getChequeByNumber: async (chequeNumber) => {
    try {
      console.log(`🚀 Fetching main cheque details for: ${chequeNumber}`);
      const response = await axios.get(`${API_BASE_URL}/cheques/${chequeNumber}`);
      console.log("✅ Main Cheque Details Received:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching main cheque details:", error.response?.data || error.message);
      return null;
    }
  },  

  // ✅ Create a New Cheque
  createCheque: async (chequeData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/cheques`, chequeData);
      return response.data;
    } catch (error) {
      console.error("❌ Error creating cheque:", error.response?.data || error.message);
      return null;
    }
  },

  // ✅ Delete a Cheque
  deleteCheque: async (chequeNumber) => {
    try {
      await axios.delete(`${API_BASE_URL}/cheques/${chequeNumber}`);
      return true;
    } catch (error) {
      console.error("Error deleting cheque:", error);
      return false;
    }
  },

  // ✅ Save New Cheque Details
// ✅ Save New Cheque Details
saveChequeDetails: async (chequeNumber, details) => {
  try {

    console.log("🔹 Sending Data to Backend:", details);

    const response = await axios.post(
      `${API_BASE_URL}/cheques/${chequeNumber}/details`,
      details
    );

    return response.data;

  } catch (error) {
    console.error("❌ Error saving cheque details:", error.response?.data || error.message);
    return null;
  }
},

// ✅ Fetch Cheque Details After Refresh
getChequeDetails: async (chequeNumber) => {
  if (!chequeNumber) {
    console.error("❌ getChequeDetails called with undefined chequeNumber!");
    return null;
  }

  try {
    console.log(`🚀 Fetching cheque details for: ${chequeNumber}`);
    const response = await axios.get(`${API_BASE_URL}/cheques/${chequeNumber}/details`);
    console.log("✅ API Response:", response.data); // 🔍 Debugging step
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching cheque details:", error.response?.data || error.message);
    return null;
  }
},

// ✅ Edit Cheque Details Dynamically
editChequeDetails: async (chequeNumber, updatedFields) => {
  try {
    if (!chequeNumber) {
      console.error("❌ editChequeDetails called with undefined chequeNumber!");
      return null;
    }

    console.log(`🚀 Sending updated cheque details for: ${chequeNumber}`, updatedFields);
    
    const response = await axios.patch(
      `${API_BASE_URL}/cheques/${chequeNumber}/details`,
      updatedFields
    );

    console.log("✅ Updated Cheque Details:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error updating cheque details:", error.response?.data || error.message);
    return null;
  }
},
// ✅ Update Cheque Status
updateChequeStatus: async (chequeNumber, status) => {
  try {
    console.log(`🚀 Updating cheque ${chequeNumber} status to: ${status}`);

    const response = await axios.patch(
      `${API_BASE_URL}/cheques/${chequeNumber}/status`,
      { status }
    );

    console.log("✅ Cheque Status Updated:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error updating cheque status:", error.response?.data || error.message);
    return null;
  }
},

// ✅ MMG Transactions

// ✅ Fetch All MMG Transactions
getMMGTransactions: async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/mmg`);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching MMG transactions:", error.response?.data || error.message);
    return [];
  }
},

// ✅ Create a New MMG Transaction (partial insert allowed)
createMMGTransaction: async (data) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/mmg`, data);
    return response.data;
  } catch (error) {
    console.error("❌ Error creating MMG transaction:", error.response?.data || error.message);
    return null;
  }
},

// ✅ Update MMG Transaction as Received
markMMGAsReceived: async (id, receivedData) => {
  try {
    const response = await axios.patch(`${API_BASE_URL}/mmg/${id}/receive`, receivedData);
    return response.data;
  } catch (error) {
    console.error("❌ Error marking MMG as received:", error.response?.data || error.message);
    return null;
  }
},

deleteMMGTransaction: async (id) => {
  try {
    await axios.delete(`${API_BASE_URL}/mmg/${id}`);
    return true;
  } catch (error) {
    console.error("❌ Error deleting MMG transaction:", error.response?.data || error.message);
    return false;
  }
},

//Loans//

  // ✅ Fetch All Loans
  getLoans: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/loans`);
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching loans:", error.response?.data || error.message);
      return [];
    }
  },

  // ✅ Fetch Single Loan Details
  getLoanById: async (loanId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/loans/${loanId}`);
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching loan details:", error.response?.data || error.message);
      return null;
    }
  },

  // ✅ Create New Loan
  createLoan: async (loanData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/loans`, loanData);
      return response.data;
    } catch (error) {
      console.error("❌ Error creating loan:", error.response?.data || error.message);
      return null;
    }
  },

  // ✅ Update Loan Details
  updateLoan: async (loanId, updatedData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/loans/${loanId}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("❌ Error updating loan:", error.response?.data || error.message);
      return null;
    }
  },

  // ✅ Delete Loan
  deleteLoan: async (loanId) => {
    try {
      await axios.delete(`${API_BASE_URL}/loans/${loanId}`);
      return true;
    } catch (error) {
      console.error("❌ Error deleting loan:", error.response?.data || error.message);
      return false;
    }
  },

  // ✅ LOAN PAYMENTS API

  // ✅ Fetch Loan Payments
  getLoanPayments: async (loanId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/loans/${loanId}/payments`);
      return response.data;
    } catch (error) {
      console.error("❌ Error fetching loan payments:", error.response?.data || error.message);
      return [];
    }
  },

  // ✅ Add Payment to Loan
  addLoanPayment: async (loanId, paymentData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/loans/${loanId}/payments`, paymentData);
      return response.data;
    } catch (error) {
      console.error("❌ Error adding payment:", error.response?.data || error.message);
      return null;
    }
  },

  // ✅ Delete Payment
  deleteLoanPayment: async (paymentId) => {
    try {
      await axios.delete(`${API_BASE_URL}/payments/${paymentId}`);
      return true;
    } catch (error) {
      console.error("❌ Error deleting payment:", error.response?.data || error.message);
      return false;
    }
  },

  // ✅ Edit Payment
  editLoanPayment: async (paymentId, paymentData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/payments/${paymentId}`, paymentData);
      return response.data;
    } catch (error) {
      console.error("❌ Error editing payment:", error.response?.data || error.message);
      return null;
    }
  },

// ✅ Fetch Loan Breakdown
getLoanBreakdown: async (loanId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/loans/${loanId}/breakdown`);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching loan breakdown:", error.response?.data || error.message);
    return null;
  }
},

// ✅ Guyana Lottery - Packed Transactions
getLottery: async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/lottery`);
    return response.data;
  } catch (error) {
    console.error("❌ Error fetching lottery transactions:", error.response?.data || error.message);
    return [];
  }
},

createLottery: async (data) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/lottery`, data);
    return response.data;
  } catch (error) {
    console.error("❌ Error creating lottery transaction:", error.response?.data || error.message);
    return null;
  }
},

toggleLotteryField: async (id, field, status) => {
  try {
    const dateField = `${field}Date`; // e.g. receivedDate
    const dateValue = status ? new Date().toISOString().split("T")[0] : "";

    const response = await axios.patch(`${API_BASE_URL}/lottery/${id}`, { 
      field, 
      status, 
      dateField, 
      dateValue 
    });

    return response.data;
  } catch (error) {
    console.error("❌ Error toggling lottery field:", error.response?.data || error.message);
    return null;
  }
},


deleteLottery: async (id) => {
  try {
    await axios.delete(`${API_BASE_URL}/lottery/${id}`);
    return true;
  } catch (error) {
    console.error("❌ Error deleting lottery transaction:", error.response?.data || error.message);
    return false;
  }
},

};


// ===== Loan Documents =====

// List documents for a loan
api.listLoanDocuments = async (loanId) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/loans/${loanId}/documents`);
    return data;
  } catch (e) {
    console.error("❌ listLoanDocuments:", e.response?.data || e.message);
    return [];
  }
};

// Upload ONE file at a time (you can call this repeatedly to add many)
api.uploadLoanDocument = async (loanId, file, meta = {}) => {
  try {
    const form = new FormData();
    form.append("files", file); // single file
    Object.entries(meta).forEach(([k, v]) => form.append(k, v ?? ""));

    const { data } = await axios.post(
      `${API_BASE_URL}/loans/${loanId}/documents`,
      form,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return data; // array of inserted rows
  } catch (e) {
    console.error("❌ uploadLoanDocument:", e.response?.data || e.message);
    throw e;
  }
};

// Delete a document row (also removes from S3 if backend is set to do so)
api.deleteLoanDocument = async (docId) => {
  try {
    await axios.delete(`${API_BASE_URL}/documents/${docId}`);
    return true;
  } catch (e) {
    console.error("❌ deleteLoanDocument:", e.response?.data || e.message);
    return false;
  }
};

// Optional: get a signed URL if your bucket is private
api.getSignedDocUrl = async (docId) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/documents/${docId}/signed`);
    return data; // { url }
  } catch (e) {
    console.warn("ℹ️ getSignedDocUrl fallback to direct URL:", e.response?.data || e.message);
    return null;
  }
};

/* =========================
   📱 PHONE CARDS (frontend)
========================= */

// tiny helper
const q = (params = {}) =>
  Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");

// List / search / filter / paginate
api.getPhoneCards = async ({ search = "", type = "", status = "", limit = 100, offset = 0 } = {}) => {
  try {
    const qs = q({ search, type, status, limit, offset });
    const { data } = await axios.get(`${API_BASE_URL}/phone-cards${qs ? `?${qs}` : ""}`);
    return data;
  } catch (error) {
    console.error("❌ Error fetching phone cards:", error.response?.data || error.message);
    return [];
  }
};

// Get one
api.getPhoneCard = async (id) => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/phone-cards/${id}`);
    return data;
  } catch (error) {
    console.error("❌ Error fetching phone card:", error.response?.data || error.message);
    return null;
  }
};

// Create
// { date, type, value, startCode, endCode, status }
api.createPhoneCard = async (payload) => {
  try {
    const { data } = await axios.post(`${API_BASE_URL}/phone-cards`, payload);
    return data;
  } catch (error) {
    console.error("❌ Error creating phone card:", error.response?.data || error.message);
    return null;
  }
};

// Update (full)
api.updatePhoneCard = async (id, payload) => {
  try {
    const { data } = await axios.put(`${API_BASE_URL}/phone-cards/${id}`, payload);
    return data;
  } catch (error) {
    console.error("❌ Error updating phone card:", error.response?.data || error.message);
    return null;
  }
};

// Toggle / set status
// status: 'available' | 'sold'
api.setPhoneCardStatus = async (id, status) => {
  try {
    const { data } = await axios.patch(`${API_BASE_URL}/phone-cards/${id}/status`, { status });
    return data;
  } catch (error) {
    console.error("❌ Error setting phone card status:", error.response?.data || error.message);
    return null;
  }
};

// Delete
api.deletePhoneCard = async (id) => {
  try {
    await axios.delete(`${API_BASE_URL}/phone-cards/${id}`);
    return true;
  } catch (error) {
    console.error("❌ Error deleting phone card:", error.response?.data || error.message);
    return false;
  }
};

// Summary for the chart (value at hand by type)
// -> [{ type: 'Digicel', value: 50000 }, ...]
api.getPhoneCardsAtHandSummary = async () => {
  try {
    const { data } = await axios.get(`${API_BASE_URL}/phone-cards/summary/at-hand`);
    return data;
  } catch (error) {
    console.error("❌ Error fetching at-hand summary:", error.response?.data || error.message);
    return [];
  }
};


/* =========================
   📡 SIM CARDS
========================= */

// Get All SIMs
api.getSimCards = async () => {
  try {
    const { data } = await axios.get(
      `${API_BASE_URL}/sim-cards`
    );
    return data;
  } catch (error) {
    console.error(
      "❌ Error fetching SIM cards:",
      error.response?.data || error.message
    );
    return [];
  }
};

// Get Single SIM
api.getSimCard = async (id) => {
  try {
    const { data } = await axios.get(
      `${API_BASE_URL}/sim-cards/${id}`
    );
    return data;
  } catch (error) {
    console.error(
      "❌ Error fetching SIM:",
      error.response?.data || error.message
    );
    return null;
  }
};

// Search SIMs
api.searchSimCards = async (query) => {
  try {
    const { data } = await axios.get(
      `${API_BASE_URL}/sim-cards/search?q=${encodeURIComponent(query)}`
    );
    return data;
  } catch (error) {
    console.error(
      "❌ Error searching SIMs:",
      error.response?.data || error.message
    );
    return [];
  }
};

// Create SIM
api.createSim = async (payload) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/sim-cards`,
      payload
    );
    return data;
  } catch (error) {
    console.error(
      "❌ Error creating SIM:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// Update SIM
api.updateSim = async (id, payload) => {
  try {
    const { data } = await axios.put(
      `${API_BASE_URL}/sim-cards/${id}`,
      payload
    );
    return data;
  } catch (error) {
    console.error(
      "❌ Error updating SIM:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// Delete SIM
api.deleteSim = async (id) => {
  try {
    await axios.delete(
      `${API_BASE_URL}/sim-cards/${id}`
    );
    return true;
  } catch (error) {
    console.error(
      "❌ Error deleting SIM:",
      error.response?.data || error.message
    );
    return false;
  }
};

/* =========================
   📋 SIM KYC
========================= */

// Get KYC
api.getSimKYC = async (simId) => {
  try {
    const { data } = await axios.get(
      `${API_BASE_URL}/sim-cards/${simId}/kyc`
    );
    return data;
  } catch (error) {
    console.error(
      "❌ Error fetching KYC:",
      error.response?.data || error.message
    );
    return null;
  }
};

// Create KYC
api.createSimKYC = async (simId, payload) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/sim-cards/${simId}/kyc`,
      payload
    );
    return data;
  } catch (error) {
    console.error(
      "❌ Error creating KYC:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// Update KYC
api.updateSimKYC = async (simId, payload) => {
  try {
    const { data } = await axios.put(
      `${API_BASE_URL}/sim-cards/${simId}/kyc`,
      payload
    );
    return data;
  } catch (error) {
    console.error(
      "❌ Error updating KYC:",
      error.response?.data || error.message
    );
    throw error;
  }
};

/* =========================
   📄 SIM DOCUMENTS
========================= */

// List Documents
api.getSimDocuments = async (kycId) => {
  try {
    const { data } = await axios.get(
      `${API_BASE_URL}/sim-kyc/${kycId}/documents`
    );
    return data;
  } catch (error) {
    console.error(
      "❌ Error fetching documents:",
      error.response?.data || error.message
    );
    return [];
  }
};

// Upload Document
api.uploadSimDocument = async (
  kycId,
  file,
  document_type
) => {

  const form =
    new FormData();

  form.append(
    "file",
    file
  );

  form.append(
    "document_type",
    document_type
  );

  try {

    const { data } =
      await axios.post(

`${API_BASE_URL}/sim-kyc/${kycId}/documents`,

        form,

        {

headers:{

"Content-Type":
"multipart/form-data"

}

        }

      );

    return data;

  } catch (error) {

    console.error(
      "❌ Error uploading document:",
      error.response?.data || error.message
    );

    throw error;

  }

};

// Signed URL
api.getSimDocumentUrl = async (docId) => {
  try {
    const { data } = await axios.get(
      `${API_BASE_URL}/sim-documents/${docId}/signed`
    );
    return data;
  } catch (error) {
    console.error(
      "❌ Error fetching document:",
      error.response?.data || error.message
    );
    return null;
  }
};

// Delete Document
api.deleteSimDocument = async (docId) => {
  try {
    await axios.delete(
      `${API_BASE_URL}/sim-documents/${docId}`
    );
    return true;
  } catch (error) {
    console.error(
      "❌ Error deleting document:",
      error.response?.data || error.message
    );
    return false;
  }
};


/* =========================
   🏦 BANK LEDGER
========================= */

// Get All Ledger Entries
api.getBankLedger = async () => {
  try {
    const { data } = await axios.get(
      `${API_BASE_URL}/bank-ledger`
    );
    return data;
  } catch (error) {
    console.error(
      "❌ Error fetching bank ledger:",
      error.response?.data || error.message
    );
    return [];
  }
};

// Get Ledger Summary
api.getBankLedgerSummary = async () => {
  try {
    const { data } = await axios.get(
      `${API_BASE_URL}/bank-ledger/summary`
    );
    return data;
  } catch (error) {
    console.error(
      "❌ Error fetching ledger summary:",
      error.response?.data || error.message
    );
    return null;
  }
};

// Create Ledger Entry
api.createBankLedgerEntry = async (payload) => {
  try {
    const { data } = await axios.post(
      `${API_BASE_URL}/bank-ledger`,
      payload
    );
    return data;
  } catch (error) {
    console.error(
      "❌ Error creating ledger entry:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// Update Ledger Entry
api.updateBankLedgerEntry = async (id, payload) => {
  try {
    const { data } = await axios.put(
      `${API_BASE_URL}/bank-ledger/${id}`,
      payload
    );
    return data;
  } catch (error) {
    console.error(
      "❌ Error updating ledger entry:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// Delete Ledger Entry
api.deleteBankLedgerEntry = async (id) => {
  try {
    await axios.delete(
      `${API_BASE_URL}/bank-ledger/${id}`
    );
    return true;
  } catch (error) {
    console.error(
      "❌ Error deleting ledger entry:",
      error.response?.data || error.message
    );
    return false;
  }
};

// Ledger Entry Types
api.getBankLedgerTypes = async () => {
  try {
    const { data } = await axios.get(
      `${API_BASE_URL}/bank-ledger/types`
    );
    return data;
  } catch (error) {
    console.error(
      "❌ Error fetching ledger types:",
      error.response?.data || error.message
    );
    return [];
  }
};


export default api;
